// Public catalog normalisation. Never promote drafts or inactive definitions.
export function publishedAssessments(entries){
  if(!Array.isArray(entries))throw new Error('The published assessment catalog has an invalid format.');
  const ids=new Set(),shortCodes=new Set();
  return entries.filter(a=>{
    if(!a||a.enabled!==true||a.id==='timesheet-to-invoice')return false;
    if(typeof a.id!=='string'||!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(a.id)||
      typeof a.shortCode!=='string'||!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(a.shortCode)||
      typeof a.title!=='string'||!a.title.trim()||
      !Array.isArray(a.questions)||!a.questions.length)return false;
    if(ids.has(a.id)||shortCodes.has(a.shortCode)||a.shortCode==='tsi')return false;
    ids.add(a.id);shortCodes.add(a.shortCode);
    return true;
  });
}
export function mergeAssessmentLibrary(legacy,published){
  const incoming=publishedAssessments(published);
  const knownIds=new Set(legacy.map(a=>a.id));
  const knownCodes=new Set(legacy.map(a=>a.shortCode));
  return [...legacy,...incoming.filter(a=>!knownIds.has(a.id)&&!knownCodes.has(a.shortCode))];
}